import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button"
import {withStyles} from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ReCaptchaV2 from 'react-google-recaptcha'
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import {getFirestore, collection, addDoc, getDocs, updateDoc} from "firebase/firestore";
import {initializeApp} from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardActions';
import Typography from "@material-ui/core/Typography";
import CardMedia from "@material-ui/core/CardMedia";
import imageUrl from './cpms.jpg'
import {withSnackbar} from "notistack";
import Paper from "@material-ui/core/Paper";
import {levenshteinDistance} from "../Levenshtein Distance/LevenshteinDistance";


let config = {
    apiKey: "AIzaSyD9b3mBPU11T_lOdtDQkPxinvuxPMM60U4",
    authDomain: "cpms2020.firebaseapp.com",
    databaseURL: "https://cpms2020-default-rtdb.firebaseio.com",
    projectId: "cpms2020",
    storageBucket: "cpms2020.appspot.com",
    messagingSenderId: "834609665122",
    appId: "1:834609665122:web:a3c8239cd507391271ad3b",
    measurementId: "G-GT86WVS49V"
};

const firebaseApp = initializeApp(config);

const db = getFirestore();


const styles = theme => ({
    selectFields: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '45ch',
            display: 'flex',
            flexWrap: 'wrap',
        },
        "& .MuiInputBase-root.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.6)" // (default alpha is 0.38)
        }
    },
});


class ProposeProject extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openCreateNewOrganization: false,
            newOrganization: {},
            organizations: [],
            similarOrganizations: [],
            token: null,
            newProject: {
                contactEmail: null,
                contactIsAdvisor: null,
                contactName: null,
                contactPhone: null,
                description: '',
                initiationDate: new Date().toLocaleString("en-CA", {hour12: false}).replace(/,/, ''),
                name: null,
                numOfSemesters: null,
                organizationId: null,
            },
            isLoaded: false,
            error: null
        };
        this.numOfSemesters = [{
            value: '2',
            label: '2'
        },
            {
                value: '1',
                label: '1'
            }]
    }

    handleCheck = (e) => {
        const project = {
            ...this.state.newProject,
            ['contactIsAdvisor']: e.target.checked
        };
        this.setState({newProject: project});
        this.forceUpdate();
    };

    handleChangeAutocomplete = (e, value) => {
        let project = {...this.state.newProject};
        if (value === null) {
            project.organizationId = null;
        } else {
            let organization = this.state.organizations.filter(obj => {
                return obj.id === value.id
            });
            project.organizationId = organization[0]
        }
        this.setState({newProject: project});
    };


    handleChange = (e) => {
        const project = {
            ...this.state.newProject,
            [e.target.name]: e.target.value
        };

        this.setState({newProject: project});
        this.forceUpdate();


    };
    handleChangeOrganization = (e) => {
        const organizations = [...this.state.organizations];
        let similarOrganizations = [];
        for (let org of organizations) {
            const ratio = levenshteinDistance(org.name, e.target.value);
            if (ratio > 0.5) {
                org.ratio = ratio;
                if (org.name.includes(e.target.value)) {
                    org.ratio = 1
                }
                similarOrganizations.push(org)
            }
        }
        similarOrganizations = similarOrganizations.sort(function (a, b) {
            return b.ratio - a.ratio;
        }).splice(0, 5);


        const organization = {
            ...this.state.newOrganization,
            [e.target.name]: e.target.value
        };
        this.setState({newOrganization: organization, similarOrganizations: similarOrganizations});
        this.forceUpdate();
    };

    handleAddProjectRequest = async (organizationObj = null) => {
        let project = {...this.state.newProject};
        if (organizationObj) {
            project.organizationId = organizationObj
        }
        try {
            const docRef = await addDoc(collection(db, "projectProposes"), project);
            await updateDoc(docRef, {
                id: docRef.id
            });
            this.setState({
                newProject: {
                    contactEmail: null,
                    contactIsAdvisor: false,
                    contactName: null,
                    contactPhone: null,
                    description: '',
                    initiationDate: new Date(),
                    name: null,
                    numOfSemesters: null,
                    organizationId: null,
                },
                newOrganization: {},
                openCreateNewOrganization: false
            });
            this.props.enqueueSnackbar('Form Submitted', {variant: 'success'});
        } catch (e) {
            this.props.enqueueSnackbar(e, {variant: 'error'});

        }

    };

    handleAddRequest = async (e) => {
        if (this.state.token !== null) {
            e.preventDefault();
            if (!this.state.newOrganization.name) {
                this.handleAddProjectRequest();
            } else {
                let organizationObj = this.state.newOrganization;
                let exists = false;
                for (let org of this.state.organizations) {
                    if (org.name === organizationObj.name) {
                        exists = true;
                        break
                    }
                }
                if (exists) {
                    alert('There is an organization with the same name, as the one you trying to add')
                } else {
                    this.handleAddProjectRequest(organizationObj);
                }
            }
        } else {
            e.preventDefault();
            alert('please verify captcha')
        }
    }
    ;


    async componentDidMount() {
        const querySnapshot = await getDocs(collection(db, "organizations"));
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id)
        });
        let organizations = [];
        try {
            const querySnapshot = await getDocs(collection(db, "organizations"));
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                organizations.push(doc.data());
            });
        } catch (e) {
            console.error("Error retrieving organizations: ", e);
        }
        this.setState({
            organizations: organizations,
            isLoaded: true,
        });
    }

    render() {
        const {classes} = this.props;

        const openCreateNewOrganization = () => {
            this.setState({openCreateNewOrganization: true});
        };
        const closeCreateNewOrganization = () => {
            this.setState({openCreateNewOrganization: false, newOrganization: {}});
        };


        const handleToken = (token) => {
            this.setState({token: token});
        };

        const handleExpire = () => {
            this.setState({token: null});
        };
        const {error, isLoaded} = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return (
                <div style={{textAlign: 'center'}}>
                    <CircularProgress size="8rem"/>
                </div>);
        } else {
            return (
                <div style={{background: '#9e9e9e1a'}}>
                    <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                        style={{minHeight: '100vh'}}
                    >
                        <Card>
                            <CardMedia
                                component="img"
                                alt="CPMS Logo"
                                height="100%"
                                style={{width: '10%', margin: 'auto'}}
                                image={imageUrl}
                                title="CPMS Logo"
                            />
                            <CardContent style={{display: 'block'}}>
                                <Typography style={{color: '#3f51b5', textAlign: 'center'}} gutterBottom
                                            variant="h5"
                                            component="h2">
                                    Project Proposal Form
                                </Typography>
                                <Typography style={{textAlign: 'center'}} gutterBottom variant="body1"
                                            component="h2">
                                    Please fill in the details
                                </Typography>
                                <form
                                    className={classes.selectFields}
                                    id="projectProposalForm"
                                    onSubmit={this.handleAddRequest}>
                                    <Grid
                                        container
                                        spacing={3}
                                    >
                                        <Grid item xs={6} style={{textAlign: '-webkit-center'}}>
                                            <TextField
                                                onChange={this.handleChange}
                                                required
                                                id="name"
                                                name="name"
                                                label='Project Name'
                                                value={this.state.newProject.name ? this.state.newProject.name : ''}
                                            />
                                            <TextField
                                                required
                                                id="description"
                                                name="description"
                                                label="Description"
                                                placeholder="Description"
                                                multiline
                                                value={this.state.newProject.description ? this.state.newProject.description : ''}
                                                onChange={this.handleChange}
                                            />
                                            {this.state.openCreateNewOrganization ?
                                                <>
                                                    <TextField
                                                        onChange={this.handleChangeOrganization}
                                                        required
                                                        name="name"
                                                        label='Organization Name'
                                                        value={this.state.newOrganization.name ? this.state.newOrganization.name : ''}
                                                    />
                                                    {
                                                        this.state.similarOrganizations.length !== 0 ?
                                                            <Paper style={{padding: '5%'}}>
                                                                <Typography style={{
                                                                    color: '#3f51b5',
                                                                    textAlign: "center"
                                                                }}>
                                                                    Existing organizations with a similar name:
                                                                </Typography>
                                                                {
                                                                    this.state.similarOrganizations.map(data => (
                                                                        <p key={data.id}
                                                                           value={data.name}>{data.name}</p>
                                                                    ))
                                                                }</Paper> : ''
                                                    }
                                                    <TextField
                                                        required
                                                        name="description"
                                                        label="Organization Description"
                                                        placeholder="Description"
                                                        multiline
                                                        value={this.state.newOrganization.description ? this.state.newOrganization.description : ""}
                                                        onChange={this.handleChangeOrganization}
                                                    />
                                                    <Button onClick={closeCreateNewOrganization}
                                                            color="primary">
                                                        Choose From Existing Organizations List
                                                    </Button>
                                                </>
                                                :
                                                <>
                                                    <Autocomplete
                                                        onChange={(e, value) => this.handleChangeAutocomplete(e, value, 'organization')}
                                                        value={this.state.newProject.organizationId}
                                                        options={this.state.organizations ? this.state.organizations : []}
                                                        getOptionLabel={(option) => (option ? option.name : '')}
                                                        getOptionSelected={(option, value) => (option.id === value.id)}
                                                        renderInput={(params) => (
                                                            <TextField {...params} fullWidth variant="standard"
                                                                       label="Organization"
                                                                       required/>
                                                        )}
                                                        filterSelectedOptions
                                                        autoHighlight
                                                    />
                                                    <Button onClick={openCreateNewOrganization}
                                                            color="primary">
                                                        New Organization
                                                    </Button>
                                                </>}
                                            <TextField
                                                onChange={this.handleChange}
                                                required
                                                id="numOfSemesters"
                                                name="numOfSemesters"
                                                label='Number Of Semesters'
                                                select
                                                value={this.state.newProject.numOfSemesters ? this.state.newProject.numOfSemesters : ''}
                                            >
                                                {this.numOfSemesters.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={6} style={{textAlign: '-webkit-center'}}>
                                            <TextField
                                                required
                                                onChange={this.handleChange}
                                                id="contactName"
                                                name="contactName"
                                                label='Contact Name'
                                                value={this.state.newProject.contactName ? this.state.newProject.contactName : ""}
                                            />
                                            <FormControlLabel
                                                labelPlacement="end"
                                                label='This contact is an advisor'
                                                control={
                                                    <Checkbox
                                                        checked={this.state.newProject.contactIsAdvisor?this.state.newProject.contactIsAdvisor:false}
                                                        color="primary"
                                                        onChange={this.handleCheck}
                                                    />}
                                            />

                                            <TextField
                                                required
                                                onChange={this.handleChange}
                                                id="contactPhone"
                                                name="contactPhone"
                                                label='Contact Cell Phone'
                                                value={this.state.newProject.contactPhone ? this.state.newProject.contactPhone : ""}
                                            />
                                            <TextField
                                                required
                                                onChange={this.handleChange}
                                                id="contactEmail"
                                                name="contactEmail"
                                                label='Contact Email'
                                                value={this.state.newProject.contactEmail ? this.state.newProject.contactEmail : ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{
                                                    textAlign: '-webkit-center'
                                                }}>
                                            <ReCaptchaV2
                                                sitekey={'6LeWLl0bAAAAAADMupviRnsu2-jfpadpL-yyozrC'}
                                                onChange={handleToken}
                                                onExpired={handleExpire}
                                            />
                                            <Button
                                                style={{
                                                    width: "25%",margin:"1%"
                                                }}
                                                type="submit"
                                                form="projectProposalForm"
                                                variant="contained" color="primary">
                                                Submit
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                        </Card>
                    </Grid>
                </div>
            );
        }
    }
}

export default withStyles(styles, {withTheme: true})

(
    withSnackbar(ProposeProject)
)
;
